@if ((fixedMainNav || fixedToolBars) && (!AppPreference.layout || AppPreference.layout != 'ROUNDED')) {
  <mat-toolbar color="primary">
    <fg-client-toolbar 
      (openSettingsRequested)="openSettingsDrawer()" 
      [sidenav]="drawer" 
      [localConfig]="localConfig"
      [toggleMenu$]="hasMiniSidenav && toggleSideMenu$">
    </fg-client-toolbar>
  </mat-toolbar>
}

@if ((AppPreference.layout == 'HORIZONTAL' && menus && menus.length > 0) && AppPreference.Layout != 'ROUNDED') {
  <mat-toolbar color="secondary" [hidden]="localConfig.isVerticalMenu">
    <fg-client-top-nav 
      [localConfig]="localConfig" 
      [isMenuLess]="isMenuLess" 
      [menus]="menus"
      [currentApp]="currentApp">
    </fg-client-top-nav>
  </mat-toolbar>
}

@if (AppPreference.layout == 'ROUNDED') {
  <fg-client-rounded-top-nav 
    (openSettingsRequested)="openSettingsDrawer()" 
    [apps]="apps" 
    [localConfig]="localConfig" 
    [menus]="menus">
  </fg-client-rounded-top-nav>
}

<mat-sidenav-container class="sidenav-container" autosize>
  <mat-sidenav 
    #drawer 
    class="sidenav fg-mat-sidenav"
    fixedInViewport="true"
    [position]="appConfig?.rightSidenavPosition ? 'end' : 'start'"
    [ngClass]="appConfig?.sidenavCustomClass"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : (AppPreference.layout === 'VERTICAL' ? 'side' : 'over')"
    [opened]="AppPreference.layout === 'VERTICAL' && !(isHandset$ | async)"
    [class.closed]="hasMiniSidenav && !isOpened"
    (mouseover)="(hasMiniSidenav && hasToggleMiniSidenav) && toggleSideMenu && drawer.open()"
    (mouseout)="(hasToggleMiniSidenav && toggleSideMenu) && drawer.close()">
    <app-client-sidenav 
      [localConfig]="localConfig" 
      [menus]="menus" 
      [currentApp]="currentApp">
    </app-client-sidenav>
  </mat-sidenav>

  <mat-sidenav-content [class.closed]="hasMiniSidenav && !isOpened">
    @if (!isHeadless) {
      <div>
        @if (!isCustomMainNav) {
          <div>
            @if (!fixedMainNav && !fixedToolBars) {
              <mat-toolbar color="primary">
                <fg-client-toolbar 
                  [localConfig]="localConfig" 
                  [sidenav]="drawer" 
                  [apps]="apps"
                  [toggleMenu$]="hasMiniSidenav && toggleSideMenu$">
                </fg-client-toolbar>
              </mat-toolbar>
            }
            @if (!fixedToolBars) {
              <mat-toolbar color="secondary" [hidden]="localConfig.isVerticalMenu">
                <fg-client-top-nav 
                  [localConfig]="localConfig" 
                  [isMenuLess]="isMenuLess" 
                  [menus]="menus"
                  [currentApp]="currentApp">
                </fg-client-top-nav>
              </mat-toolbar>
            }
          </div>
        }
        <div>
          @if (isCustomMainNav) {
            <div>
              <div class="d-none d-md-block d-lg-block">
                <div class="row fg-header">
                  <div class="col-md-2 fg-logo-wrapper">
                    <a id="toolbar-menu fg-logo" [routerLink]="goToLandingPage()">
                      @if (!isMenuLess) {
                        <img class="fg-primary-logo" src="assets/img/logo.png" [alt]="logoDescription">
                      }
                      @if (isMenuLess) {
                        <img class="fg-primary-logo menuless-logo" src="/assets/img/logo_v_2.png" [alt]="logoDescription">
                      }
                    </a>
                  </div>
                  <div class="col-md-10">
                    @if (!isMenuLess) {
                      <mat-toolbar color="primary">
                        <fg-client-toolbar 
                          [sidenav]="drawer" 
                          [apps]="apps"
                          [toggleMenu$]="hasMiniSidenav && toggleSideMenu$">
                        </fg-client-toolbar>
                      </mat-toolbar>
                    }
                    @if (!appConfig?.isVertical) {
                      <mat-toolbar color="secondary">
                        <fg-client-top-nav 
                          [isMenuLess]="isMenuLess" 
                          [menus]="menus"
                          [currentApp]="currentApp">
                        </fg-client-top-nav>
                      </mat-toolbar>
                    }
                    @if (appConfig?.hideAppOnNavbarNavigation) {
                      <mat-toolbar color="secondary">
                        <fg-client-top-nav 
                          [isMenuLess]="isMenuLess" 
                          [menus]="menus"
                          [currentApp]="currentApp">
                        </fg-client-top-nav>
                      </mat-toolbar>
                    }
                  </div>
                </div>
              </div>

              @if (showMobileTopNav) {
                <div class="d-md-none fg-mobile-app-header">
                  <mat-toolbar color="primary">
                    <fg-client-toolbar 
                      [sidenav]="drawer" 
                      [apps]="apps"
                      [toggleMenu$]="hasMiniSidenav && toggleSideMenu$">
                    </fg-client-toolbar>
                  </mat-toolbar>
                  <div class="row fg-header align-items-center">
                    <div class="col-2 text-center">
                      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="onToggleMenu(drawer)">
                        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                      </button>
                    </div>
                    <div class="col-3 fg-logo-wrapper">
                      <a id="fg-logo" [routerLink]="goToLandingPage()">
                        <img src="assets/img/logo.png" [alt]="logoDescription ? logoDescription : 'logo'">
                      </a>
                    </div>
                    <div class="col-2">
                      @if (!isMenuLess && appConfig?.hideAppOnNavbarNavigation && appConfigSetting.notificationConfig?.enableNotification) {
                        <span class="notification-button">
                          <button mat-button [matMenuTriggerFor]="topNav?.notifyMenu" class="notification-icon-button">
                            @if (!notificationIsRead) {
                              <i class="fa fa-bell" aria-hidden="true"></i>
                            }
                            @if (notificationIsRead) {
                              <i [matBadge]="notificationCount" class="fa fa-bell" aria-hidden="true"></i>
                            }
                          </button>
                        </span>
                      }
                    </div>
                    <div class="col-5 float-right text-right">
                      <app-logout-button [isCustomMainNav]="isCustomMainNav"></app-logout-button>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (isHeadless && customHeader) {
      <div>
        <mat-toolbar color="tertiary">
          <fg-client-top-nav 
            [customHeader]="customHeader" 
            [apps]="apps" 
            [isMenuLess]="isMenuLess"
            [menus]="menus">
          </fg-client-top-nav>
        </mat-toolbar>
      </div>
    }

    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>